export default [
  {
    meta: {
      icon: "iconfont iconjichuxinxiguanli",
      title: "云展厅管理",
      uri: "/newRetail/carcloud",
    },
    subMenus: [
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "直播列表",
          uri: "/newRetail/carcloud/livelist",
        },
        component: () => import("./liveManages/list.vue"),
        path: "/livelist",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "线索列表",
          uri: "/newRetail/carcloud/cluelist",
        },
        component: () => import("./clueManage/list.vue"),
        path: "/cluelist",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "经销商管理",
          uri: "/newRetail/carcloud/dealerCodeList",
        },
        component: () => import("./dealerCodeManage/list.vue"),
        path: "/dealerCodeList",
      },
      // {
      //   meta: {
      //     icon: 'iconfont iconxiaoshoushujuguanli',
      //     title: '优惠活动管理',
      //     uri: '/carcloud/discount',
      //   },
      //   component: () => import('./discount'),
      //   path: '/discount',
      // },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "短视频列表",
          uri: "/newRetail/carcloud/shortVideo",
        },
        component: () => import("./shortVideo"),
        path: "/shortVideo",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "留资落地页管理",
          uri: "/newRetail/carcloud/retainedCapital",
        },
        component: () => import("./retainedCapital"),
        path: "/retainedCapital",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "车型配置管理",
          uri: "/newRetail/carcloud/vehicleConfiguration",
        },
        component: () => import("./vehicleConfiguration"),
        path: "/newRetail/carcloud/vehicleConfiguration",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "养修预约管理",
          uri: "/newRetail/carcloud/maintenanceAppointment",
        },
        component: () => import("./maintenanceAppointment"),
        path: "/newRetail/carcloud/maintenanceAppointment",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "报名活动管理",
          uri: "/newRetail/carcloud/registerActivity",
        },
        component: () => import("./registerActivity/index.vue"),
        path: "/newRetail/carcloud/registerActivity",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "经销商人员管理",
          uri: "/newRetail/carcloud/dealerMemberManage",
        },
        component: () => import("./dealerMemberManage/index.vue"),
        path: "/newRetail/carcloud/dealerMemberManage",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "渠道管理",
          uri: "/newRetail/carcloud/channelList",
        },
        component: () => import("./channel-list/index.vue"),
        path: "/newRetail/carcloud/channel-list",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "投放管理",
          uri: "/newRetail/carcloud/putList",
        },
        component: () => import("./put-list/index.vue"),
        path: "/newRetail/carcloud/put-list",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "道路救援券码管理",
          uri: "/newRetail/carcloud/roadService",
        },
        component: () => import("./roadService/index.vue"),
        path: "/newRetail/carcloud/roadService",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "PDD兑换券码管理",
          uri: "/newRetail/carcloud/PDDCouponCodeManagement",
        },
        component: () => import("./PDDCouponCodeManagement/index.vue"),
        path: "/newRetail/carcloud/PDDCouponCodeManagement",
      }
    ],
  },
];
